import React, { useContext, useEffect, useState } from 'react';
import Toggle from '../components/Toggle';
import { GlobalContext } from '../reducers/global';
import getChild from '../api/getChild';
import Graph from '../components/Graph';
import langs from '../translations/langs';
import dataSetUrls from '../constants/dataSetUrls';
import Layout from '../components/Layout';
import ResultsHeader from '../components/ResultsHeader';
import Button from '../components/Button';
import Back from '../components/Back';
import PopUp from '../components/PopUp';
import Download from '../components/DownloadPdf';
import DownloadXml from '../components/DownloadXml';

const Results = ({ page, setPage }) => {
    const {
        state: {
            child,
            measurements,
            growthChart,
            options: { measurementSystem, language, dataSet },
        },
        dispatch,
    } = useContext(GlobalContext);
    const [dataType, setDataType] = useState('');
    const [onTrack, setOnTrack] = useState(null);
    const { results } = langs[language];
    const { dataSets } = langs[language];
    const currentDataSetId = dataSets.filter((val) => val.name === dataSet)[0].id;
    const growthMeasures = growthChart.GrowthCharts.ChildData.Measures;
    window.dataLayer = window.dataLayer || [];

    useEffect(() => {
        /* eslint-disable array-callback-return */
        growthMeasures.map((measure) => {
            if (measure.HeightWarning === 'true' && measure.HeightRelativeValue < -2) {
                window.dataLayer.push({ event: 'rangeTracker', rangeTrack: 'under range' });
            } else if (measure.HeightWarning === 'true' && measure.HeightRelativeValue > 2) {
                window.dataLayer.push({ event: 'rangeTracker', rangeTrack: 'over range' });
            } else if (measure.HeightWarning === 'false') {
                window.dataLayer.push({ event: 'rangeTracker', rangeTrack: 'in range' });
            }
        });
        /* eslint-enable array-callback-return */
    }, [onTrack]);

    useEffect(() => {
        getChild(dataSetUrls[currentDataSetId], child, measurements.values).then((res) => {
            dispatch({
                type: 'GROWTHCHART_UPDATE',
                ...res,
            });
        });
    }, [child, measurements, dispatch, currentDataSetId]);

    useEffect(() => {
        const measures = growthChart.GrowthCharts.ChildData.Measures;
        const last = growthChart.GrowthCharts.ChildData.Measures[measures.length - 1];
        if (last) {
            if (last.HeightWarning === 'true') {
                setOnTrack(false);
            } else if (last.IsValidHeight === 'false') {
                setOnTrack(false);
            } else {
                setOnTrack(true);
            }
        }
    }, [growthChart]);

    const convertToImperial = (cm) => {
        const inches = cm / 2.54;
        const feet = Math.trunc(inches / 12);
        const inch = Math.trunc(inches % 12);
        return `${feet}' ${inch}"`;
    };
    const moreData = () => {
        setPage('step3');
    };

    return (
        <Layout
            type={dataType}
            url={dataSetUrls[currentDataSetId]}
            wcd={growthChart.GrowthCharts.Data}
            name="dataType"
            leftVal="Height"
            leftText={results.heightLabel}
            rightVal="Weight"
            rightText={results.weightLabel}
            setValue={setDataType}
            page={page}
        >
            <Back
                onClick={() => {
                    setPage('returnStep1');
                }}
            />
            <ResultsHeader
                growthText={results.growthTargetText}
                growthVal={onTrack ? results.onTrack : results.notOnTrack}
                heightText={results.heightTargetText}
                heightVal={
                    growthChart.GrowthCharts.ChildData.TargetHeight && measurementSystem !== 'imperial'
                        ? growthChart.GrowthCharts.ChildData.TargetHeight
                        : convertToImperial(growthChart.GrowthCharts.ChildData.TargetHeight)
                }
                byAge={results.byAge}
                popUpLink={results.targetHeightLink}
                popUpModal={results.targetHeightModal}
            />
            <p className="paragraph">
                {child.sex === 'M' ? results.heightGraphTextSon : results.heightGraphTextDaughter}
            </p>
            <p className="paragraph">{onTrack ? results.onTrackText : results.notOnTrackText}</p>
            <p className="paragraph">{results.recommendText}</p>
            {window.innerWidth < 992 ? (
                <div className="graph-mobile">
                    <Toggle
                        name="dataType"
                        leftVal="Height"
                        leftText={results.heightLabel}
                        rightVal="Weight"
                        rightText={results.weightLabel}
                        setValue={setDataType}
                    />
                    <Graph type={dataType} url={dataSetUrls[currentDataSetId]} wcd={growthChart.GrowthCharts.Data} />
                </div>
            ) : null}
            <PopUp linkText={results.sdLink} modalText={results.sdModal} />
            <PopUp linkText={results.averageHeightLink} modalText={results.averageHeightModal} />
            <div className="buttons-col results-page">
                <Button buttonStyle="secondary" text={results.previousMeasurements} onClick={moreData} />
                <Download id="calculator-download-pdf" text={results.downloadPdf} wcd={growthChart.GrowthCharts.Data} />
                <DownloadXml id="calculator-save-xml" text={results.save} wcd={growthChart.GrowthCharts.Data} />
            </div>
        </Layout>
    );
};

export default Results;
